import React, { createContext, useEffect } from 'react'

import { initialState } from './state'
import { wizardStore } from 'services/state'
import { wizardContainers } from './constants'

export const ScenarioWizardComponentsContext = createContext()

const WizardContainer = ({ open, close, data }) => {
  const {
    type,
    externalWizardComponents: externalComponents,
    ...dataRest
  } = data

  useEffect(() => {
    return () => {
      wizardStore.set(initialState)
    }
  }, [])

  const WizardContainer = wizardContainers[type]

  if (!WizardContainer) {
    console.error(`Wizard type ${type} not supported.`)
    return null
  }

  return (
    <ScenarioWizardComponentsContext.Provider value={externalComponents}>
      <WizardContainer data={dataRest} open={open} close={close} />
    </ScenarioWizardComponentsContext.Provider>
  )
}

export default WizardContainer
